import { FeatureUnavailable } from "@cynthai/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useAppCapabilities } from "@/core/hooks/use-app-capabilities";
import { denyRouteAccess } from "@/core/lib/route-access";
import { isCorporateFinanceMember } from "@/features/corporate-finance/lib/access";

export const Route = createFileRoute("/_protected/corporate-finance")({
  beforeLoad: ({ context, ...guard }) => {
    if (!isCorporateFinanceMember(context.user)) {
      denyRouteAccess(guard, "corporate_finance_membership");
    }
  },
  component: CorporateFinanceLayout,
});

function CorporateFinanceLayout() {
  const appCapabilities = useAppCapabilities();

  if (!appCapabilities.fabric) {
    return <FeatureUnavailable />;
  }

  return <Outlet />;
}
